// extracted by mini-css-extract-plugin
export default {"title":"Vdwcsxlgl5blNLFC3_vO","tabsList":"JGSsdonzx1uoDAsnEQA6"};